import reelsCss from "./reels.css?inline";

// Parsed once, used by the grid shadow root via adoptedStyleSheets.
let _sheet: CSSStyleSheet | null = null;

export function getReelsSheet(): CSSStyleSheet {
  if (!_sheet) {
    _sheet = new CSSStyleSheet();
    _sheet.replaceSync(reelsCss);
  }
  return _sheet;
}

// Injected once into document.head for the fullscreen overlay (light DOM portal).
let _overlayEl: HTMLStyleElement | null = null;

export function ensureOverlayCss(): void {
  if (_overlayEl || typeof document === "undefined") return;
  _overlayEl = document.createElement("style");
  _overlayEl.textContent = reelsCss;
  document.head.appendChild(_overlayEl);
}
